import { Link } from 'react-router-dom';

import { Button } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';

import { Icon } from '@eduzz/ui-antd-theme';

const EditButton = ({
  id,
  parentId,
  disabled,
  onClick,
  href
}: {
  id: string;
  parentId?: string;
  disabled?: boolean;
  onClick?: () => void;
  href?: string;
}) => {
  const isChild = !!parentId;
  const finalRoute = isChild
    ? `/producer/product/editproduct/${parentId}/${id}`
    : `/producer/product/editproduct/${id}`;

  const button = (
    <Button
      id='quickview-product-edit-button'
      block
      color='default'
      variant='filled'
      onClick={onClick}
      disabled={disabled}
      icon={<Icon.Pencil />}
    >
      Editar
    </Button>
  );

  return (
    <PermissionHide action='myeduzz:meus-produtos:editar'>
      {href ? (
        <a href={href} className='block w-full'>
          {button}
        </a>
      ) : (
        <Link to={finalRoute} className='block w-full'>
          {button}
        </Link>
      )}
    </PermissionHide>
  );
};

export default EditButton;
